import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription, filter } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { selectPermittedCommands } from 'src/app/store/permissions/permissions.selector';
import { PermittedCommand } from 'src/app/model/permission';
import * as PermissionActions from 'src/app/store/permissions/permissions.actions';
import { Site } from 'src/app/model/site';
import { selectCurrentSite } from 'src/app/store/site/site.selector';
import { PermissionEmailDialogComponent } from '../permission-email-dialog/permission-email.dialog.component';
import { PermissionDialogComponent } from '../permission-dialog/permission.dialog.component';

@Component({
	selector: 'app-permissions-button-bar',
	templateUrl: './permissions-button-bar.component.html',
	providers: [ConfirmationService, DialogService]
})

export class PermissionsButtonBarComponent implements OnInit, OnDestroy {
	permittedCommands: PermittedCommand[] = [];
	permittedCommands$: Observable<PermittedCommand[] | undefined>;
	permittedCommandsSub: Subscription | undefined;

	ref: DynamicDialogRef | undefined;

	acceptButtonStyle: string;
	rejectButtonStyle: string;
	permissionsMenuitems: MenuItem[] = [];

	confirmDeleteSub: Subscription;

	site: Site;
	site$: Observable<Site | undefined>;
	siteSub: Subscription;

	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MIN_MD_WIDTH_EXT = 670;
	MIN_WIDTH_MX7 = 1700;

	constructor(
		private store: Store<AppState>,
		private translate: TranslateService,
		public dialogService: DialogService,
		public confirmationService: ConfirmationService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.permittedCommands$ = this.store.select(selectPermittedCommands);
		this.site$ = this.store.select(selectCurrentSite);
	}

	subscribeAll(): void {
		this.siteSub = this.site$
			.pipe(filter(s => !!s))
			.subscribe((site) => {
				this.site = site;
				this.permissionsMenuitems = [
					// { label: this.translate.instant('ADD_PERMISSION'), icon: 'pi cm-plus', command: () => this.addPermission()},
					{ label: this.translate.instant('CUSTOMIZE_EMAIL'), icon: 'pi cm-pencil', command: () => this.customizeEmail() },
				];
			}
			);
		this.permittedCommandsSub = this.permittedCommands$.subscribe(permittedCommands => {
			this.permittedCommands = permittedCommands;
		});
		/* this.permissionsExpiredSub = this.store.select('permission', 'permissionsExpired').subscribe(permissionsExpired => {
				this.permissionsExpired = permissionsExpired;
		}); */
	}

	ngOnDestroy(): void {
		this.permittedCommandsSub?.unsubscribe();
		// this.permissionsExpiredSub?.unsubscribe();
	}

	ngOnInit(): void {
		this.subscribeAll();

		this.onResize();
	}

	addPermission(): void {
		if (this.anyPossibleCommand()) {
			this.store.dispatch(PermissionActions.resetPermissionForm());
			this.ref = this.dialogService.open(PermissionDialogComponent, {
				header: this.translate.instant('ADD_PERMISSION'),
				width: '70vw',
				breakpoints: { '1600px': '98vw' },
				contentStyle: { overflow: 'auto' },
				data: {}
			});
		} else {
			if (this.site.Timezone === '') {
				this.rejectButtonStyle = "p-button-danger";
				this.confirmationService.confirm({
					header: this.translate.instant('ADD_TIMEZONE_SITE'),
					message: this.translate.instant('ADD_TIMEZONE_SITE_WARNING'),
					rejectLabel: this.translate.instant('CLOSE'),
					icon: 'pi cm-alert',
					reject: () => {
					}
				});
			} else {
				this.rejectButtonStyle = "p-button-danger";
				this.confirmationService.confirm({
					header: this.translate.instant('WARNING'),
					message: this.translate.instant('FUNCTIONALITY_UNAVAILABLE'),
					rejectLabel: this.translate.instant('CLOSE'),
					icon: 'pi cm-alert',
					reject: () => {
					}
				});
			}
		}
	}

	customizeEmail(): void {
		this.store.dispatch(PermissionActions.resetPermissionTemplateForm());
		this.ref = this.dialogService.open(PermissionEmailDialogComponent, {
			header: this.translate.instant('CUSTOMIZE_EMAIL'),
			width: '80vw',
			breakpoints: { '1220px': '98vw' },
			contentStyle: { overflow: 'auto' },
			data: {}
		});
	}

	anyPossibleCommand(): boolean {
		return this.permittedCommands.length > 0;
	}

	/* showExpiredList() {
		 this.store.dispatch(PermissionActions.getPermissionsExpired());

		 this.deleteAll();
	} */

	/* deleteAll(): void {
		 const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
			  minWidth: '20vw',
			  maxWidth: '50vw',
			  data: { title: 'DELETE_ALL_EXPIRES', body: 'DELETE_ALL_PERMISSION_WARNING' }
		 });
		 

		 this.confirmDeleteSub = dialogRef.afterClosed().subscribe(result => {
			  if (result === 'success') {
					const listPermission = this.permissionsExpired;
					if (listPermission) {
						 for (const permissionExp of listPermission) {
							  this.store.dispatch(PermissionActions.deletePermission({ permission: permissionExp }));
						 }
					}
			  }
		 });  
	} */

	isFinalUsers(): boolean {
		return this.site !== undefined && this.site !== null && !this.site.CurrentlyOwned;
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

}
